import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Map } from 'immutable';
import { Link } from 'react-router';
import capitalize from 'lodash/capitalize';

import DropDownButton from '../../ui/DropDownButton';

class GoToDropdownButton extends Component {
  static propTypes = {
    routing: PropTypes.string,
    currentOrganizationId: PropTypes.string,
  };

  builLinkUrl = (linkType) => {
    switch (linkType) {
      case 'project':
        return '/projects';
      case 'account':
        return '/accounts';
      case 'organization':
        return '/organizations';
      default:
        return '';
    }
  }

  buildLink = (linkType) =>
    (
      <Link key={linkType} className="dropdown-item" to={this.builLinkUrl(linkType)}>
        {`My ${capitalize(linkType)}s`}
      </Link>
    );

  buildDropdownList = () => {
    const { userRoles } = this.props;

    return ['project', 'account', 'organization'].reduce((prev, item) => {
      if (userRoles && userRoles.get(item, Map()).size > 0) {
        prev = prev.concat(this.buildLink(item));
      }

      return prev;
    }
    , []);
  }
  render() {
    return (
      <li className="nav-item nav-item-margin">
        <DropDownButton
          bClassName={'btn-btn-outline-secondary goto-dropdown'}
          title={'Go To'}
          hideToggle={false}
        >
          { this.buildDropdownList() }
        </DropDownButton>
      </li>
    );
  }
}

export default GoToDropdownButton;



// WEBPACK FOOTER //
// ./src/components/buttons/GoToDropdownButton/GoToDropdownButton.js